// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YDVZ","image":"Header_image__1hwgm","name":"Header_name__3sYAK","info":"Header_info__R5h3C","infoRow":"Header_infoRow__3SMg3"};